import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';

/*
 * Copyright © 2019-2021. Verizon Connect Ireland Limited. All rights reserved.
 */
class ButtonSizeDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    set vzcButtonSize(value) {
        ['extra-small', 'small', 'large'].forEach(size => this.renderer.removeClass(this.elementRef.nativeElement, `vzc-${size}`));
        if (value !== 'extra-small' && value !== 'small' && value !== 'large') {
            return;
        }
        this.renderer.addClass(this.elementRef.nativeElement, `vzc-${value}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ButtonSizeDirective, selector: "[vzcButtonSize]", inputs: { vzcButtonSize: "vzcButtonSize" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[vzcButtonSize]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { vzcButtonSize: [{
                type: Input
            }] } });

/*
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */
class ButtonSizeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeModule, declarations: [ButtonSizeDirective], exports: [ButtonSizeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonSizeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [ButtonSizeDirective],
                    exports: [ButtonSizeDirective],
                }]
        }] });

/*
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonSizeDirective, ButtonSizeModule };
